import { Component, OnInit, inject } from "@angular/core";
import {
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
  FormsModule,
  ReactiveFormsModule
} from "@angular/forms";
import { ResourceStore } from "@app/services/store/resource-store";
import { ResourceModel } from "@app/models/rest/resource";
import { RosterAssignmentStore } from "@app/services/store/roster/roster-assignment-store";
import { debounceTime, finalize, switchMap, tap } from "rxjs/operators";
import { SubDivision } from "@app/models/rest/roster/sub-division";
import { RosterAssignment } from "@app/models/rest/roster/roster-assignment";
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
  MatDialogContent,
  MatDialogActions
} from "@angular/material/dialog";
import { ServiceErrorHandlerService } from "@app/view/shared/service-error-handler.service";
import { ResourceChooserDialogComponent } from "@app/view/shared/resource-chooser-dialog/resource-chooser-dialog.component";
import { Roster } from "@app/models/rest/roster/roster";
import { CdkScrollable } from "@angular/cdk/scrolling";
import { MatButton } from "@angular/material/button";
import { MatIcon } from "@angular/material/icon";
import {
  MatFormField,
  MatLabel,
  MatSuffix
} from "@angular/material/form-field";
import { MatSelect } from "@angular/material/select";
import { MatOption } from "@angular/material/core";
import { MatInput } from "@angular/material/input";
import {
  MatDatepickerInput,
  MatDatepickerToggle,
  MatDatepicker
} from "@angular/material/datepicker";
import { DialogHeaderComponent } from "../../../../shared/dialog-header/dialog-header.component";

@Component({
  selector: "app-add-assignment-dialog",
  templateUrl: "./add-assignment-dialog.component.html",
  styleUrls: ["./add-assignment-dialog.component.css"],
  imports: [
    FormsModule,
    ReactiveFormsModule,
    CdkScrollable,
    MatDialogContent,
    MatButton,
    MatIcon,
    MatFormField,
    MatLabel,
    MatSelect,
    MatOption,
    MatInput,
    MatDatepickerInput,
    MatDatepickerToggle,
    MatSuffix,
    MatDatepicker,
    MatDialogActions,
    DialogHeaderComponent
  ]
})
export class AddAssignmentDialogComponent implements OnInit {
  resourceStore = inject(ResourceStore);
  assignmentStore = inject(RosterAssignmentStore);
  serviceErrorHandler = inject(ServiceErrorHandlerService);
  protected dialog = inject(MatDialog);
  dialogRef = inject<MatDialogRef<AddAssignmentDialogComponent>>(MatDialogRef);
  data = inject<{
    roster: Roster;
    subDivisions: SubDivision[];
  }>(MAT_DIALOG_DATA);

  assignmentForm: UntypedFormGroup = new UntypedFormGroup({
    startDate: new UntypedFormControl("", Validators.required),
    endDate: new UntypedFormControl(""),
    resource: new UntypedFormControl("", Validators.required),
    subDivision: new UntypedFormControl("", Validators.required)
  });
  filteredResources: ResourceModel[] = [];
  public isLoading: boolean;

  displayFn(resource: ResourceModel) {
    if (resource) {
      return resource.name;
    }
  }

  displaySubDivisionFn(subDivision: SubDivision) {
    if (subDivision) {
      return subDivision.name;
    }
  }

  ngOnInit() {
    console.log(this.assignmentForm.get("resource"));

    this.assignmentForm
      .get("resource")
      .valueChanges.pipe(
        debounceTime(300),
        tap(() => (this.isLoading = true)),
        switchMap((value) =>
          this.resourceStore
            .advancedSearchObservable({ params: { projection: "details" } }, [
              {
                key: "name",
                operation: "Contains",
                value: value ? value : "donotmatchanything"
              }
            ])
            .pipe(finalize(() => (this.isLoading = false)))
        )
      )
      .subscribe((resources) => {
        console.log("got results", resources);
        this.filteredResources = resources.resources;
      });
  }

  submit() {
    console.log("submitting", this.assignmentForm.value, this.data);
    let rosterAssignment = new RosterAssignment();
    rosterAssignment.startDate = this.assignmentForm.value.startDate;
    rosterAssignment.endDate = this.assignmentForm.value.endDate;
    rosterAssignment.resource = this.assignmentForm.value.resource;
    rosterAssignment.subDivision = this.assignmentForm.value.subDivision;
    // The roster is associated through the subdivision

    this.assignmentStore.create(rosterAssignment).subscribe(
      () => {
        this.dialogRef.close(true);
      },
      (error) => {
        this.serviceErrorHandler.handleError(error);
      }
    );
  }

  cancel() {
    this.dialogRef.close(false);
  }

  chooseResource() {
    const dialogRef = this.dialog.open(ResourceChooserDialogComponent);
    dialogRef.afterClosed().subscribe((result) => {
      console.log("The dialog was closed", result);
      this.assignmentForm.patchValue({ resource: result.data });
    });
  }
}
